// extracted by mini-css-extract-plugin
module.exports = {"MapaTitol":"VisualitzacioMapaTitol_MapaTitol__1lW5-"};